import { Button, Grid, makeStyles, MenuItem, Paper, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import UniDialog from '../Common/UniDialog';
import _ from 'lodash';
import { DataGrid } from '@material-ui/data-grid';
import ErrorIcon from '@material-ui/icons/Error';
import { useDispatch, useSelector } from 'react-redux';
import { completeTask, createAutoTask, forwardOrder } from '../../actions/orderExchangeActions';
import { getBranchById, getUserPreference } from '../../utilities/common';
import { showAlertSnackbar } from '../../reducers/uiSlice';
import FullscreenLoading from '../Common/FullscreenLoading';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        paddingTop: 20,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4)
    },
    groupSection: {
        marginRight: theme.spacing(4),
        display: 'flex',
        alignItems: 'center'
    },
    dataGridSection: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(1)
    }
}))

export default function ScanProcess(props) {
    const { t } = useTranslation('orderForwardTool');
    const classes = useStyles();
    const dispatch = useDispatch();

    const userPref = getUserPreference();

    const columns = [
        { field: 'id', hide: true },
        {
            field: 'tno',
            headerName: t('tracking_no'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'warehouse',
            headerName: t('warehouse'),
            flex: 1,
            headerAlign: 'center',
            valueFormatter: (params) => getBranchById(params.value).name,
            align: 'center',
            sortable: false
        },
        {
            field: 'third_party_tno',
            headerName: t('third_party_tracking_no'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div>
                    {params.value || '-'}
                </div>
            ),
            sortable: false
        },
        {
            field: 'transship_status',
            headerName: t('status'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {
                        params.row.transship_status === '3' &&
                        <span><ErrorIcon style={{ color: 'red', marginLeft: 5 }} /></span>
                    }
                </div>
            ),
            sortable: false
        },
        {
            field: 'actions',
            headerName: t('actions'),
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => (
                <Button
                    onClick={() => { window.open(params.row.label_url, '_blank'); }}
                    color='primary'
                >
                    {t('print')}
                </Button>
            ),
            align: 'center',
            sortable: false
        }
    ]

    const thirdPartyList = [
        {
            id: -1,
            code: 'auto',
            text: t('auto')
        },
        {
            id: 0,
            code: 'CP',
            text: 'Canada Post'
        },
        {
            id: 1,
            code: 'FD',
            text: 'FedEx'
        },
        {
            id: 2,
            code: 'GV',
            text: 'GV'
        }
    ]

    const [trackingNo, setTrackingNo] = useState();
    const [orderList, setOrderList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [thirdParty, setThirdParty] = useState('auto');

    const handleKeyUp = (e) => {
        if (e.keyCode === 13) {
            handleScan();
        }
    }

    const handleScan = async () => {
        try {
            if (trackingNo) {
                setLoading(true);
                const resCreate = await dispatch(createAutoTask({
                    tno: trackingNo,
                    warehouse: userPref.userCity
                }))
                const resForward = await dispatch(forwardOrder({
                    task_id: resCreate.id,
                    tno: trackingNo,
                    carrier_code: thirdParty === 'auto' ? '' : thirdParty
                }))
                let res = resForward;
                res[0].label_url = resForward[0].lable_info[0].labelPath;
                setOrderList(res);
            }
        } catch (err) {
            setOrderList([]);
            dispatch(showAlertSnackbar({ message: t('update_failure'), type: 'error' }))
        } finally {
            setLoading(false);
            setTrackingNo('');
        }
    }

    const createRows = () => {
        if (orderList?.length > 0) {
            return orderList.map((row) => {
                const { order_id, ...rest } = row
                return { id: order_id, ...rest }
            })
        } else {
            return [];
        }
    }

    return (
        <Paper className={classes.root}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <TextField
                    select
                    label={t('third_party')}
                    value={thirdParty}
                    onChange={(e) => setThirdParty(e.target.value)}
                    variant='outlined'
                    fullWidth
                    id='orderforwardtool-scan-thirdparty-textfield'
                    style={{ marginRight: 20 }}
                >
                    {
                        thirdPartyList.map((thirdParty) => (
                            <MenuItem key={thirdParty.id} value={thirdParty.code}>{thirdParty.text}</MenuItem>
                        ))
                    }
                </TextField>
                <span style={{ marginRight: 10, minWidth: 'fit-content' }}>{t('scan_parcel_or_manual_input')}</span>
                <TextField
                    label={t('tracking_no')}
                    value={trackingNo}
                    onChange={(e) => setTrackingNo(e.target.value)}
                    variant='outlined'
                    fullWidth
                    onKeyUp={(e) => handleKeyUp(e)}
                    id='orderforwardtool-scan-search-textfield'
                    style={{ marginRight: 20 }}
                />
                <Search
                    color='primary'
                    style={{ cursor: 'pointer' }}
                    id='orderforwardtool-scan-search-button'
                    onClick={handleScan}
                />
            </div>
            <DataGrid
                className={classes.dataGridSection}
                style={{ height: '80vh', marginTop: 20 }}
                alignItems="center"
                rows={createRows()}
                columns={columns}
                pageSize={20}
                disableSelectionOnClick
            />
            <FullscreenLoading open={loading} />
        </Paper>
    );
}